import { colors, radius } from '@mobi/component-library/Foundations'
import React from 'react'
import styled from '@emotion/styled'

type StepGroupProps = {
  totalSteps: number
  currentStep: number
}

export const StepGroup = ({ totalSteps, currentStep }: StepGroupProps) => {
  if (totalSteps <= 0 || currentStep < 0) return null

  return (
    <ContainerStyled role='progressbar' aria-label={`Step ${currentStep} of ${totalSteps}`}>
      {Array.from({ length: totalSteps }).map((_, i) => {
        const isActive = i < currentStep
        return <div key={i} data-active={isActive ? 'true' : 'false'} />
      })}
    </ContainerStyled>
  )
}

const ContainerStyled = styled.div({
  display: 'flex',
  gap: '0.5rem',
  alignItems: 'center',
  width: '100%',

  '& > div': {
    flex: 1,
    minWidth: 0,
    height: '0.8rem',
    borderRadius: radius.pill,
    transition: 'background 200ms',
    background: colors.neutral[200],

    '&[data-active="true"]': {
      background: colors.studio[500],
    },
  },
})
